import React, { useEffect, Suspense, useCallback } from 'react';
import { Layout, Spin, message, Tooltip } from 'antd';
import { Route, Switch, useLocation } from 'react-router-dom';
import LeftMenu from './LeftMenu';
import ToggleBar from './ToggleBar';
import { getNaviFuncList } from './api';
import { getMenus } from './utils/dealRouter';
import BreadCrumb from './BreadCrumb';
import MenuState from './Container';
import { getFlatMenuKeys, getFlatMenuFunc } from './utils/siderMenuUtils';
import { ImenuContainer, RouterType } from './type';
import { setAppId, setVariablePathname } from './utils/globalVariable';
import NotExist from './NotExist';
import './style';

const { Sider, Content } = Layout;
const wordIconUrl =
    'https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202209/01/0acb3_20220901104955.png';

const MenuContainer = (props: ImenuContainer) => {
    return (
        <MenuState.Provider initialState={props}>
            <BasicLayout {...props} />
        </MenuState.Provider>
    );
};

const BasicLayout = (props: ImenuContainer) => {
    const { router, userId, appId, option, token } = props;
    const menuState = MenuState.useContainer();

    const location: any = useLocation();

    const getQueryString = (name: string) => {
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
        const r = location?.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return '';
    };

    const dealRouters = (data: RouterType[]) => {
        const result: any = getMenus(router, data, props.showPathNotInRouters);
        const fatmap:any = getFlatMenuFunc(result.menuData);
        menuState.setAuthRouter(result.menuData);
        menuState.setVisibleMenu(result.menuVisibleData);
        menuState.setFlatMenu(fatmap);
        menuState.setBreadMenu(result.breadcrumbNameMap);
        menuState.setFlatOriginRouter(result.flatOriginRouters);
        menuState.setNotVerifyFlatMenus(result.notVerifyFlatMenus);
        menuState.setLoading(false);
        sessionStorage.setItem(
		                	`${appId}-authorityRouters-Functions`,
		                	JSON.stringify(fatmap),
		                );
    };

    // 获取路由 权限 列表
    const getNavigators = async () => {
        let queryRouter = false;
        if (option.cacheMenu) {
            // 缓存菜单
            const cacheRouters = sessionStorage.getItem(`${appId}-authorityRouters`)
                ? JSON.parse(sessionStorage.getItem(`${appId}-authorityRouters`) || '')
                : null;

            cacheRouters ? dealRouters(cacheRouters) : (queryRouter = true);
        } else {
            queryRouter = true;
        }
        if (queryRouter) {
            menuState.setLoading(true);
            const res: any = await getNaviFuncList(userId, { appId, token });
            if (res.status === 0) {
                if (res.result && res.result.list.length > 0) {
                    option.cacheMenu &&
                        sessionStorage.setItem(
                        	`${appId}-authorityRouters`,
                        	JSON.stringify(res.result.list),
                        );
                    dealRouters(res.result.list);
                } else {
                    message.warning('路由列表为空');
                    menuState.setLoading(false);
                }
            } else {
                const { info, result, status } = res;
                props.getNavigationError({
                    info,
                    result,
                    status,
                    loginError: [553649434, 553649437, 553649438, 553649443].includes(res.status),
                });
                message.error(res.info);
            }
        }
    };

    useEffect(() => {
        setAppId(appId);
        router && appId && userId && getNavigators();
    }, [appId, userId, router]);
    useEffect(() => {
        menuState.setNotExist(option.notExist);
        menuState.setNnoPermission(option.noPermission);
    }, [props.option]);

    useEffect(() => {
        setVariablePathname(location.pathname);
    }, [location]);

    // 权限系统菜单列表中不存在本地设置不需校验权限菜单时，加入列表。在路由中注册
    const dealNotVerifyMenus = (menus: RouterType[]): RouterType[] => {
        if (!menuState.notVerifyFlatMenus.length) {
            return menus;
        }
        menuState.notVerifyFlatMenus.forEach(item => {
            const index = menus.findIndex(menu => menu.url === item.url);
            if (index === -1) {
                menus.push({
                    ...item,
                    child: undefined,
                });
            }
        });
        return menus;
    };
    /**
     * @description 获取路由列表
     * @param routers RouterType
     */
    const getRouterList = useCallback(
        (routers: RouterType[]): RouterType[] => {
            let keys = new Array();
            routers.forEach((item: RouterType) => {
                item.notIsExist && (item.component = NotExist);
                keys.push(item);
                if (item.child) {
                    keys = keys.concat(getRouterList(item.child));
                }
            });
            return dealNotVerifyMenus(keys);
        },
        [menuState.notVerifyFlatMenus, menuState.authRouter],
    );
    return (
        <Layout className="content-layout-view auth-content-layout-view">
            {!option.hideMenu && getQueryString('nw') !== '1' && (
                <Sider
                    collapsible
                    theme={option.menuTheme || 'light'}
                    width={option.menuWidth || 200}
                    trigger={null}
                    collapsedWidth={0}
                    className={
                        option.menuTheme && option.menuTheme === 'dark'
                            ? 'darkMenuTheme'
                            : 'lightMenuTheme'
                    }
                    collapsed={menuState.menuCollapsed}
                    style={{
                        textAlign: 'left',
                        boxShadow: '1px 0px 0px 0px #ccc',
                        height: `calc(100vh - ${option.subtractHeight}px)`,
                    }}
                >
                    <div style={{ overflowY: 'auto', height: '100%' }}>
                        {option.systemName || option.wordUrl ? (
                            <h3
                                className="slider-menu-title"
                            >
                                <span className="system-name">{option.systemName || ''}</span>

                                {option.wordUrl ? (
                                    <a
                                        href={option?.wordUrl}
                                        target="_blank"
                                        className="word-url"
                                    >
                                        <Tooltip
                                            title="使用手册"
                                            mouseLeaveDelay={0}
                                            placement="right"
                                        >
                                            <img
                                                width={18}
                                                src={wordIconUrl}
                                                alt="" />
                                        </Tooltip>
                                    </a>
                                ) : null}
                            </h3>

                        ) : null}

                        {menuState.visibleMenu.length ? (
                            <LeftMenu
                                {...props}
                                routers={menuState.visibleMenu}
                                flatMenuKeys={getFlatMenuKeys(menuState.visibleMenu)} />
                        ) : null}
                    </div>
                    <ToggleBar />
                </Sider>
            )}
            <Layout style={{ height: `calc(100vh - ${option.subtractHeight}px)` }}>
                {!option.hideBreadCrumb && <BreadCrumb />}
                <Layout
                    className="authority-menu-content-view"
                    id="content-view"
                    style={{
                        height: `calc(100vh - ${
                            !option.hideBreadCrumb ? option.subtractHeight : 0
                        }px - 48px)`,
                        background: option.contentColor,
                    }}
                >
                    <Content>
                        <Suspense
                            fallback={(
                                <div
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        textAlign: 'center',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Spin
                                        spinning
                                        style={{ background: option.contentColor || '#f0f2f5' }}
                                    >
                                        <p style={{ fontSize: 18, marginTop: 20 }}>loading...</p>
                                    </Spin>
                                </div>
                            )}
                        >
                            <Switch>
                                {getRouterList(menuState.authRouter).map((item: RouterType) => {
                                    return (
                                        <Route
                                            key={item.url}
                                            exact
                                            path={item.url}
                                            component={item.component} />
                                    );
                                })}
                                <Route
                                    key="404page"
                                    component={NotExist} />
                            </Switch>
                        </Suspense>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};
export default MenuContainer;
